import { render, staticRenderFns } from "./fireFightingDocumentEditor.vue?vue&type=template&id=20630989"
import script from "./fireFightingDocumentEditor.vue?vue&type=script&lang=js"
export * from "./fireFightingDocumentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20630989')) {
      api.createRecord('20630989', component.options)
    } else {
      api.reload('20630989', component.options)
    }
    module.hot.accept("./fireFightingDocumentEditor.vue?vue&type=template&id=20630989", function () {
      api.rerender('20630989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/sdf/fireFightingDocumentEditor.vue"
export default component.exports